import React, { useState, useEffect } from 'react';

import HelptapColorPicker from 'generics/components/color-picker';

import FourInputs from '../four-inputs';

import './index.scss';

function BoxShadowInput(props) {

  const [rootState, setRootState] = useState({
    boxShadow: getDefaultValue()
  });

  useEffect(function onBoxShadowChange() {

    props.onChange(rootState.boxShadow);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rootState.boxShadow]);

  function getDefaultValue() {

    if (props.boxShadow !== void 0 && props.boxShadow !== null) {
      return props.boxShadow;
    }

    const boxShadow = {
      horizontalOffset: 0,
      verticalOffset: 0,
      blurRadius: 0,
      spreadRadius: 0,
      color: '#000'
    };

    return boxShadow;

  }

  function updateBoxShadow(fieldName, value) {

    setRootState(function updateRootState(rootState) {

      return {
        ...rootState,
        boxShadow: {
          ...rootState.boxShadow,
          [fieldName]: value
        }
      };

    });

  }

  function handleNumericalValuesChange(values) {

    const [
      horizontalOffset,
      verticalOffset,
      blurRadius,
      spreadRadius
    ] = values;

    setRootState(function updateRootState(rootState) {

      return {
        ...rootState,
        boxShadow: {
          ...rootState.boxShadow,
          horizontalOffset,
          verticalOffset,
          blurRadius,
          spreadRadius
        }
      };

    });

  }

  function handleShadowColorChange(color) {

    updateBoxShadow('color', color);

  }

  function renderNumberInputs() {

    const boxShadow = rootState.boxShadow;

    const fourSidesProperties = {
      values: [
        boxShadow.horizontalOffset,
        boxShadow.verticalOffset,
        boxShadow.blurRadius,
        boxShadow.spreadRadius
      ],
      labels: ['X', 'Y', 'Blur', 'Spread'],
      onChange: handleNumericalValuesChange
    };

    return <FourInputs {...fourSidesProperties} />;

  }

  function renderColorPicker() {

    const colorPickerProperties = {
      color: rootState.boxShadow.color,
      onChange: handleShadowColorChange
    };

    return <div className="node-properties-menu-color-picker-wrapper">
      <HelptapColorPicker {...colorPickerProperties} />
    </div>;

  }

  function renderMain() {

    return <div id="editor-box-shadow-input-main">
      {renderNumberInputs()}
      {renderColorPicker()}
    </div>;

  }

  return renderMain();

}

export default BoxShadowInput;